import React from "react";
import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function TasksLoader(_: Props) {
  return (
    <div className={styles.tasks}>
      <div className={styles.task}>
        <div className={styles.nameBox}>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.statusBox}>
          <Skeleton className={styles.status} />
        </div>
        <div className={styles.endDateBox}>
          <Skeleton className={styles.endDate} />
        </div>
      </div>
      <div className={styles.task}>
        <div className={styles.nameBox}>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.statusBox}>
          <Skeleton className={styles.status} />
        </div>
        <div className={styles.endDateBox}>
          <Skeleton className={styles.endDate} />
        </div>
      </div>
      <div className={styles.task}>
        <div className={styles.nameBox}>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.statusBox}>
          <Skeleton className={styles.status} />
        </div>
        <div className={styles.endDateBox}>
          <Skeleton className={styles.endDate} />
        </div>
      </div>
      <div className={styles.task}>
        <div className={styles.nameBox}>
          <Skeleton className={styles.name} />
        </div>
        <div className={styles.statusBox}>
          <Skeleton className={styles.status} />
        </div>
        <div className={styles.endDateBox}>
          <Skeleton className={styles.endDate} />
        </div>
      </div>
    </div>
  );
}

export { TasksLoader };
